<template>
  <div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card color="grey lighten-5">
          <v-flex xs12 sm12>
            <v-toolbar  size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">{{dialog_baslik}}</v-toolbar-title>
            </v-toolbar>
          </v-flex>
          <v-card-text>
              <v-flex pa-1 xs12 sm12 md12>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
              <v-layout wrap>
                <div class="flex md12">

                  <div>
                    <v-text-field label="Bölüm Kodu" :color="color" v-model="Bolum.SectionCode" :error-messages="errors.collect('sirketkod')"
                      v-validate="'required'" data-vv-name="sirketkod" required>
                    </v-text-field>
                  </div>

                  <v-text-field label="Bölüm Adı" :color="color" v-model="Bolum.SectionName" :error-messages="errors.collect('sirketadi')"
                    v-validate="'required'" data-vv-name="sirketadi" required>
                  </v-text-field>



                  <v-text-field label="Bölüm Dış Kodu" :color="color" v-model="Bolum.SectionOuterCode">
                  </v-text-field>
                </div>
              </v-layout>
</v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-show="m === true">
              <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
              <v-btn id="bsil" color="blue darken-1" flat @click="deletebolum()">Sİl</v-btn>
            </div>

            <v-btn color="blue darken-1" flat @click="vazgec()">Vazgeç</v-btn>
            <div v-show="k === true">
              <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout row wrap>


 <v-toolbar   size="120px" dark color="info">
          <v-toolbar-title >Bölüm Kodu</v-toolbar-title>
          <v-spacer></v-spacer>
           <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
          <v-btn hidden="xs" flat @click="bolumekle()"> Bölüm Ekle
            <v-icon right dark>add_box</v-icon>
          </v-btn>
        </v-toolbar>


    </v-layout>

    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>

      </v-card-title>
      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items" :search="search3">
        <v-progress-linear slot="progress"   indeterminate></v-progress-linear>

        <template slot="items" slot-scope="props">
          <tr @click="Getir(props.item)" item>
            <td class="text-xs-left">{{ props.item.BolumKodu }}</td>
            <td class="text-xs-left">{{ props.item.BolumAdi }}</td>
            <td class="text-xs-left">{{ props.item.BolumDisKodu }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
        </v-alert>
      </v-data-table>
    </v-card>

    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        headers: [{
            text: 'Bölüm Kodu',
            value: 'BolumKodu'
          },
          {
            text: 'Bölüm Adı ',
            value: 'BolumAdi'
          },
          {
            text: 'Bölüm Dış Kodu',
            value: 'BolumDisKodu'
          }


        ],
        loading: false,
        color: 'orange darken-4',
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        Bolum: {

          CompanyCode: '',
          SectionCode: '',
          SectionName: '',
          SectionOuterCode: ''

        },
        state: [],
        progress: false,
        dialog_baslik: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        bankakod: '',
        bankaadi: '',
        dictionary: {
          custom: {
            sirketkod: {
              required: () => 'Bu alan boş bırakılamaz',
            },
            sirketadi: {
              required: () => 'Bu alan boş bırakılamaz',
            }
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      Getir(v) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Bolum.SectionCode = v.BolumKodu
        this.Bolum.SectionName = v.BolumAdi
        this.Bolum.SectionOuterCode = v.BolumDisKodu



        this.k = false
        this.m = true
        this.$validator.reset()


        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Bölüm Güncelle'


      },
      deletebolum: deletebolum,
      bolumekle: bolumekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
  }



  function Kaydet() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.$validator.validateAll().then((result) => {
      if (result) {

        var params = {
          CompanyCode: credentials.SirketKodu,
          SectionCode: this.Bolum.SectionCode,
          SectionName: this.Bolum.SectionName,
          SectionOuterCode: this.Bolum.SectionOuterCode
        }
        this.$http.post(auth.API_URL + 'api/Definitions/SectionAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          this.dialog = false


          var params1 = {
            CompanyCode: credentials.SirketKodu
          }
          this.$http.post(auth.API_URL + 'api/Definitions/SectionList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable.'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable.'
              this.snackbar = true
            }
          })
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          }
        })
      }


    })

  }

  function bolumekle() {

    this.dialog = true
    this.Sirket = {}
    this.dialog_baslik = 'Bölüm Ekle'



    this.Bolum.SectionCode=null
    this.Bolum.SectionName=null
    this.Bolum.SectionOuterCode=null
    this.m = false
    this.k = true
    this.codegorunum = true
    this.$validator.reset()

  }

  function beforeMount() {
    this.progress = true
    var credentials1 = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials1.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/Definitions/SectionList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.progress = false
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.progress = false
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }

  function deletebolum() {



    if (window.confirm('Bölüm\'ü silmek istediğinizden eminmisiniz?')) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.Bolum.CompanyCode = credentials.SirketKodu

      var params = this.Bolum
      this.$http.post(auth.API_URL + 'api/Definitions/SectionDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true

var credentials1 = JSON.parse(window.localStorage.getItem('credentials'));
          var params1 = {
            CompanyCode: credentials1.SirketKodu
          }

          this.$http.post(auth.API_URL + 'api/Definitions/SectionList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
    this.$validator.validateAll().then((result) => {
      if (result) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.Bolum.CompanyCode = credentials.SirketKodu
        var params = this.Bolum


        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Definitions/SectionUpdate', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true



            var params1 = {
              CompanyCode: credentials.SirketKodu
            }

            this.$http.post(auth.API_URL + 'api/Definitions/SectionList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>